<div [className]="commonService.chatExist? 'app-container' : 'app-container-wo'">
    <div class="content-container">
        <div class="row m-0">
            <div class="col-md-2 p-0"></div>
            <div class="col-sm-12 col-md-3 ps-0 pe-5">
                <div class="">
                    <div class="app-heading">{{'resource.title' | translate}}</div>
                    <div class="app-content-body">
                        {{ 'resource.subContent' | translate}}
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-md-5 p-0 position-relative">
                <div class="content-container-frame">
                    <div class="pe-2" [ngClass]="{ 'content-container-overflow':commonService.chatExist, 'content-container-overflow-wo': !commonService.chatExist}">
                        <div *ngFor="let resource of resourceList;let i=index">
                            <div class="mt-3">
                                <a class="resource-card" href="{{'resource.resource'+resource+'.url' | translate}}" target="_blank">
                                    <span class="material-icons-outlined resource-arrow">north_east</span>
                                    <div class="resource-card-content">
                                        <div>{{'resource.resource'+resource+'.header' | translate}}
                                            <!-- <div class="text-dark"> {{'resource.resource'+resource+'.subheader' | translate}}</div> -->
                                        </div>
                                    </div>
                                </a>
                                <div class="resource-sub-text px-1 py-2">{{'resource.resource'+resource+'.text'| translate}}</div>
                                <div class="resource-divider" *ngIf="i< resourceList.length - 1"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-2 p-0"></div>
        </div>
    </div>
</div>